import LanguageIcon from '@mui/icons-material/Language';
import StorefrontIcon from '@mui/icons-material/Storefront';
import {Box} from '@mui/material';
import {useEffect, useState} from 'react';
import {useMutation, useQueryClient} from 'react-query';
import {useDispatch, useSelector} from 'react-redux';
import {RootState} from '../../..';
import MutliImageSqureCard from '../../../components/card/squreCard/mutliImageSqureCard';
import WalletLoanCard from '../../../components/card/walletCard/walletLoanCard';
import EmptyStyle from '../../../components/emptyStyles/emptyStyle';
import CheckDocumentIcon from '../../../components/icons/CheckDocumentIcon';
import BasicTab from '../../../components/tab/basicTab';
import {WALLET_KEY} from '../../../config/cacheKey';
import {IGetStoresResponse} from '../../../models/store.model';
import {IGetCustomerWalletsInfoResponse} from '../../../models/wallet.model';
import {
    changeRouteType,
    getpervInnerState,
} from '../../../redux/handleBackBtn/handleBackBtnSlice';
import {
    setHeaderTitle,
    setPageData,
} from '../../../redux/headerTitle/headerTitleSlice';
import {GetStores} from '../../../services/store.service';
import {IStoreContainerOriginal} from '../../navigationButtonComponents/walletContainer/IStoreContainer';
import SellerSkeleton from './sellerSkeleton';
import {useNavigate} from 'react-router-dom';

export default function Sellers({
    setState,
    setTabChild,
}: IStoreContainerOriginal) {
    const dispatch = useDispatch();

    const selectedCategoryId = useSelector(
        (state: RootState) => state.headerTitleSlice.storeTab
    );

    const randomKeyForDispatch = Math.random();

    const [finalTabs, setFinalTabas] = useState<any>();
    const queryClient = useQueryClient();
    const walletKey: string = queryClient.getQueryData(WALLET_KEY)!;
    const wallets: IGetCustomerWalletsInfoResponse[] =
        queryClient.getQueryData('wallets')!;
    const selectedWallet = wallets?.filter(
        (wallet) => wallet?.key === walletKey
    );
    const onNavigate = useNavigate();

    let count = 0;
    const {mutate: GetStoresMutate, isLoading} = useMutation(GetStores, {
        onSuccess: (data: IGetStoresResponse) => {
            if (data) {
                let tabs: any[] = [];
                if (data.onlineStores != null && data.onlineStores.length > 0) {
                    tabs.push({
                        id: count,
                        title: 'آنلاین',
                        icon: <LanguageIcon />,
                        child: (
                            <MutliImageSqureCard
                                stores={data.onlineStores!}
                                handleClick={handleClick}
                            ></MutliImageSqureCard>
                        ),
                        dividerNeeded: true,
                    });
                    count++;
                }
                if (
                    data.offlineStores != null &&
                    data.offlineStores.length > 0
                ) {
                    tabs.push({
                        id: count,
                        title: 'حضوری',
                        icon: <StorefrontIcon />,
                        child: (
                            <MutliImageSqureCard
                                stores={data.offlineStores!}
                                handleClick={handleClick}
                            ></MutliImageSqureCard>
                        ),
                        dividerNeeded: true,
                    });
                }
                setFinalTabas(tabs);
            }
        },
        onError: () => {},
    });

    useEffect(() => {
        // time token todo
        dispatch(changeRouteType({routeType: 'child'}));
        dispatch(
            getpervInnerState({prevInnerState: `store ${randomKeyForDispatch}`})
        );
        dispatch(
            setHeaderTitle({
                header: 'فروشندگان',
                color: 'var(--header-color)',
                parentRoute: '',
            })
        );
        GetStoresMutate({
            walletKey: walletKey === '' ? undefined : walletKey,
            categoryId: parseInt(selectedCategoryId!),
        });
    }, []);

    const handleClick = (id: number) => {
        onNavigate(`/home/store-detail?storeId=${id}`);
        // dispatch(setPageData({page: 'sellers', id}));
        // setState!('sellerInfo');
    };

    if (isLoading) {
        return <SellerSkeleton />;
    }

    return (
        <div
            className={
                walletKey
                    ? `overflow-y-auto h-[calc(100svh-120px)]`
                    : `overflow-y-auto h-[calc(100svh-60px)]`
            }
        >
            {walletKey && (
                <Box
                    sx={{
                        boxShadow: '0px 0px 4px rgba(0,0,0,0.3)',
                        background: 'var(--input-bg-color)',
                        height: '25%',
                        display: 'flex',
                        alignItems: 'center',
                        width: '100%',
                        paddingX: '40px',
                    }}
                >
                    <WalletLoanCard
                        amount={selectedWallet[0]?.balance}
                        date={selectedWallet[0]?.expirationDatePersian}
                        title={selectedWallet[0]?.title}
                        color={selectedWallet[0]?.colorHexCode}
                    />
                </Box>
            )}
            {!isLoading && finalTabs != undefined && finalTabs?.length !== 0 ? (
                <div>
                    <BasicTab
                        tabs={finalTabs}
                        backgroundColor="var(--header-color)"
                        dividerNeeded={true}
                    ></BasicTab>
                </div>
            ) : (
                <div className="h-[80%]">
                    <EmptyStyle
                        text="فروشگاهی برای خدمت رسانی وجود ندارد."
                        icon={
                            <CheckDocumentIcon className="mt-10 text-[var(--primary-text-color)]" />
                        }
                        emphasisedWordsColor="#BBA57A"
                        emphasisedWords={[]}
                    />
                </div>
            )}
        </div>
    );
}
